import { TFunction } from 'i18next';

import { Customer, CustomerFormFieldErrors } from '../../interfaces/Customer';
import ValidationService from '../../services/ValidationService';

type OnFieldChange = <T extends keyof Customer>(params: {
  customer: Customer | undefined;
  fieldName: T;
  setCustomer: (customer: Customer) => void;
  value: Customer[T];
}) => void;

const onFieldChange: OnFieldChange = ({
  value, fieldName, customer, setCustomer
}): void => {
  if (customer) {
    const newCustomer: Customer = { ...customer };
    newCustomer[fieldName] = value;
    setCustomer(newCustomer);
  }

  return undefined;
};


const getInitialFieldErrors = (): CustomerFormFieldErrors => ({
  email: undefined,
  phoneNumber: undefined,
  mobileNumber: undefined,
});

const validateFields = (
  customer: Customer | undefined,
  setFieldErrors: (next: CustomerFormFieldErrors) => void,
  t: TFunction
) => {
  if (!customer) return false;

  const { email, phoneNumber, mobileNumber } = customer;

  const nextFieldErrors = getInitialFieldErrors();

  if (!email) {
    nextFieldErrors.email = t('customerSection:formErrors:emailRequired');
  } else if (!ValidationService.isEmailValid(email)){
    nextFieldErrors.email = t('customerSection:formErrors:emailInvalid');
  }

  if (!phoneNumber && !mobileNumber) {
    nextFieldErrors.phoneNumber = t('customerSection:formErrors:phoneNumberRequired');
    nextFieldErrors.mobileNumber = t('customerSection:formErrors:phoneNumberRequired');
  }

  if (phoneNumber && !ValidationService.isPhoneValid(phoneNumber)) {
    nextFieldErrors.phoneNumber = t('customerSection:formErrors:phoneNumberInvalid');
  }

  if (mobileNumber && !ValidationService.isPhoneValid(mobileNumber)) {
    nextFieldErrors.mobileNumber = t('customerSection:formErrors:phoneNumberInvalid');
  }

  setFieldErrors(nextFieldErrors);

  const isValid = !Object.values(nextFieldErrors).some(fieldError => fieldError);

  return isValid;
};

export default {
  onFieldChange,
  getInitialFieldErrors,
  validateFields,
};
